/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import { getApiUrl } from "@/utils/baseUrl";

export interface TerminalTarget {
  kind: "router" | "local" | "agent";
  id: string;
  name: string;
}

export async function getTerminalTargets(): Promise<{ enabled: boolean; targets: TerminalTarget[] }> {
  const r = await fetch(getApiUrl("/terminal/targets"));
  if (!r.ok) return { enabled: false, targets: [] };
  return r.json();
}

/** Asks the panel for a one-time ticket; the caller has already confirmed with the user. */
export async function openTerminal(kind: string, id: string): Promise<string> {
  const r = await fetch(getApiUrl("/terminal/open"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ kind, id }),
  });
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(body.error || "Could not open a console");
  return body.ticket as string;
}

/** The WebSocket URL for a ticket, on the same origin as the page. */
export function terminalSocketUrl(ticket: string): string {
  const u = new URL(getApiUrl("/ws/terminal"), window.location.href);
  u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
  u.searchParams.set("ticket", ticket);
  return u.toString();
}
